// extracted by mini-css-extract-plugin
module.exports = {"alertContainer":"styles_alertContainer__3AyWf","icon":"styles_icon__3fhSJ","text":"styles_text__1n--b","title":"styles_title__3W9fd"};